const apiUrl = process.env.REACT_APP_API_URL;
export const GetProjectes = async (userId: string = "0") => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes?nom=&userId=${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
